import { carouselItems } from '@/mocks/homepage';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            深度策划的漫画专题，每期聚焦一个精彩主题
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-[10px] font-medium rounded-full bg-accent-500 text-background-50">
                  {item.tag}
                </span>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="text-base font-heading text-foreground-900 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-primary-500 font-medium mb-3">{item.subtitle}</p>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200/70 flex items-center gap-1 text-xs text-primary-500 font-medium">
                  <span>浏览专题</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}